import { DataAttributeDefinitions } from 'scrivito'

import { pisaTimerecordPositionDataClass } from './Pisa/pisaTimerecordPositionDataClass'

const attributes: DataAttributeDefinitions = {}

export const TimerecordPosition = pisaTimerecordPositionDataClass(attributes)
